'use strict';

bbw.directive.bbwFixedPosition = ['$document', '$window', 'bbw.OffsetCalcSvc', function($document, window, offsetCalcSvc) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var el = element[0];

            var cfg = scope.$eval(attrs.bbwFixedPosition),
                elAxis = document.querySelector(cfg.axis);

            var bottomPos, elBottom;

            if (angular.isDefined(cfg.bottom)) {
                bottomPos = parseInt(cfg.bottom);
                if (isNaN(bottomPos)) {
                    bottomPos = undefined;
                    elBottom = document.querySelector(cfg.bottom);
                }
            }

            var calcBottom = function() {
                if (angular.isDefined(bottomPos)) {
                    return bottomPos;
                }
                if (elBottom) {
                    if (elBottom.offsetHeight) {
                        var clientHeight = $document[0].body.clientHeight;
                        var elBottomOffset = clientHeight + $document[0].documentElement.scrollTop - offsetCalcSvc.top(elBottom);
                        if (elBottomOffset > 0) {
                            return elBottomOffset;
                        }
                    }
                    return 0;
                }
                return undefined;
            };

            if (!elAxis) {
                return;
            }

            function isFixed() {
                var isFixed = (window.getComputedStyle(el).position === 'fixed');
                if (!isFixed) {
                    el.style.top = 'inherit';
                    el.style.left = 'inherit';
                    el.style.width = 'inherit';
                    el.style.height = 'inherit';
                    return false;
                }
                return true;
            }

            function doMove() {
                var top = offsetCalcSvc.top(elAxis);
                var left = offsetCalcSvc.left(elAxis);
                el.style.top = top + 'px';
                el.style.left = left + 'px';
                return {top: top, left: left};
            }

            function move() {
                if (!isFixed()) {
                    return;
                }
                doMove();
            }

            function setPositions(e) {
                if (!isFixed()) {
                    return;
                }
                doMove();
                var clientHeight = $document[0].body.clientHeight;
                var coords = doMove();
                var width = elAxis.offsetWidth;
                var bottom = calcBottom();
                if (angular.isDefined(bottom)) {
                    var height = clientHeight - coords.top - bottom;
                    el.style.height = height + 'px';
                } else {
                    el.style.height = 'inherit';
                }
                el.style.width = width + 'px';
            }

            setPositions();
            setTimeout(setPositions, 300);
            window.addEventListener('resize', setPositions);
            window.addEventListener('scroll', move);
            scope.$on('update-fixed-height', setPositions);
            scope.$on('$destroy', function() {
                window.removeEventListener('resize', setPositions);
                window.removeEventListener('scroll', move);
            });
        }
    };
}];
